import { takeLatest, all, put, call } from 'redux-saga/effects';
import delay from '@redux-saga/delay-p';
import ActivateUserPanelactions from './actions';

function* activateUserRequestHandler({ payload: { formRef, isValid } }) {
  if (!isValid) {
    yield call(delay, 500);
    yield put(ActivateUserPanelactions.onActivateUserFailure());
  } else {
    formRef.method = 'post';
    formRef.submit();
  }
}

function* activateUserFormSagas() {
  yield all([takeLatest(ActivateUserPanelactions.onActivateUserRequest.getType(), activateUserRequestHandler)]);
}

export default activateUserFormSagas;
